import { render } from "./TheIssuesList.vue?vue&type=template&id=ad01a492"
import script from "./TheIssuesList.vue?vue&type=script&lang=js"
export * from "./TheIssuesList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__